export enum EBrand {
  Markets77 = 'Markets77',
  FrontBroker = 'FrontBroker',
  ChallengesTrades = 'ChallengesTrades',
  TradeGlobal = 'TradeGlobal',
  Finexo = 'Finexo',
  HeroMarkets = 'HeroMarkets',
  PipsTrades = 'PipsTrades',
  TrdFx = 'TrdFx',
  TradeItaly = 'TradeItaly',
}
